import { render, staticRenderFns } from "./ChinaTradePanel.vue?vue&type=template&id=f120d2b0&scoped=true"
import script from "./ChinaTradePanel.vue?vue&type=script&lang=js"
export * from "./ChinaTradePanel.vue?vue&type=script&lang=js"
import style0 from "./ChinaTradePanel.vue?vue&type=style&index=0&id=f120d2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f120d2b0",
  null
  
)

export default component.exports